import React, { useState } from 'react';
import { SkitterFrame } from '../Models/SkitterFrame';
import { BaseButton } from '../Controls/Button/BaseButton';
import './css/SkitterBookFrameSelection.css';


interface SkitterBookFrameSelectionProps {
    frames: string[];
    onClick?: (selectedImage: string) => void;
}

export const SkitterBookFrameSelection: React.FC<SkitterBookFrameSelectionProps> = ({ frames, onClick }) => {
    return (
        <div className="skitterbook-frame-selection-container">
            <div className="frame-list">
                {
                    frames.map((frameBase64, index) =>
                        <div key={`frame_${index}`}>
                            <BaseButton ariaLabel={`framebutton-${index}`}
                                className="component-button"
                                onClick={() => {
                                    onClick?.(frameBase64);
                                }}>
                                <img
                                    src={`data:image/jpeg;base64,${frameBase64}`}
                                    alt={`Frame ${index}`}
                                    onLoad={e => {
                                        const el = e.currentTarget;
                                        const orientation = el.naturalWidth >= el.naturalHeight ? "landscape" : "portrait";
                                    }}
                                />
                            </BaseButton>
                        </div>
                    )
                }
            </div>
        </div>
    );
};
